import React, { useCallback } from 'react';
import { IconButton } from '@cian/ui-kit';

import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';

import * as s from './ModalHeader.css';

export interface IModalHeader {
  children: React.ReactNode;
  hideCloseButton?: boolean;
  onClose?(e: React.MouseEvent): void;
}

/**
 * Зона шапки для модального окна с крестиком
 */
export const ModalHeader = ({ children, onClose, hideCloseButton }: IModalHeader) => {
  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();

      if (onClose) {
        onClose(e);
      }
    },
    [onClose],
  );

  return (
    <div className={s['wrapper']}>
      <div className={s['content']}>{children}</div>

      {!hideCloseButton && (
        <div className={s['close-button-wrapper']}>
          <IconButton icon={<IconActionClose16 />} onClick={handleClick} />
        </div>
      )}
    </div>
  );
};
